import React from 'react';
import { StyledTR } from './styles';

export type TRProps = React.HTMLAttributes<HTMLTableRowElement>;

const TR: React.FC<TRProps> = props => <StyledTR {...props} />;

export default TR;
